


















































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import { SpaceInspectionUserRole, InspectionMemberTable } from '@/config/map.conf';
import AddAdminModal from './addAdminModal.vue';

@Component({
    components: {
        AddAdminModal
    }
})
export default class SpaceInspectionAdmin extends Vue {
    $mtd: any;
    modalType: 'admin' | 'inspector' = 'admin';
    addSpaceAdminVisible: boolean = false;
    userRoleMap: CommonTypes.mapObject = SpaceInspectionUserRole;
    tableList: CommonTypes.mapObject[] = InspectionMemberTable;
    userMap: CommonTypes.mapObject = {
        admin: [],
        inspector: []
    };

    created() {
        this.getMembers();
    }
    async getMembers(role?: string) {
        const res = await api.inspectApi.getInspector({ objectId: this.spaceId, role: role ? [role] : [] });
        const { code, data } = res;
        if (code === 200) {
            if (role) {
                this.userMap[role.toLowerCase()] = data[role.toLowerCase()] || [];
            } else {
                this.userMap.admin = data.admin || [];
                this.userMap.inspector = data.inspector || [];
            }
        }
    }
    updateMembers() {
        if (this.modalType === 'admin') {
            this.getMembers('ADMIN');
        } else {
            this.getMembers('INSPECTOR');
        }
    }
    deleteMember(row) {
        const _this = this;
        this.$mtd
            .confirm({
                title: `是否确认删除：${row.name}？`,
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '删除',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    try {
                        await api.inspectApi.deleteInspector({
                            nameList: [row.name],
                            role: row.role,
                            objectId: this.spaceId
                        });
                        this.$mtd.message({
                            message: '删除成功',
                            type: 'success'
                        });
                        await _this.getMembers(row.role);
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(e => e);
    }
    handleAddUser(type: 'admin' | 'inspector') {
        this.addSpaceAdminVisible = true;
        this.modalType = type;
    }
    // 设置成员组织架构信息
    setDept(bg: string, bu: string, org: string) {
        let dept: string = '';
        if (bg) {
            dept += `${bg}/`;
        }
        if (bu) {
            dept += `${bu}/`;
        }
        if (org) {
            dept += `${org}`;
        }
        return dept;
    }
    formatOrg(org) {
        const orgArr = (org && org.split('-')) || [];
        if (orgArr[0] === 'IPH') {
            orgArr.shift();
        }
        return orgArr.join('/');
    }
    get spaceId() {
        return parseInt(this.$route.params.id, 10);
    }
}
